/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import CheckCircleIcon from "assets/icons/check-circle-broken.svg";
import CheckIcon from "assets/icons/check.svg";
import StarsIcon from "assets/icons/sparkles-gradient.svg";
import { remoteImageStaticUrl } from "common/utils/remote-image";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";

export default function ArtistEditsInformation({ isMobile = false, onClose, ...restProps }: any) {
  const beforeImage = remoteImageStaticUrl("2/gen/user-retention-modal-pin-before.png", {
    w: 275,
    h: 275
  });
  const afterImage = remoteImageStaticUrl("2/gen/user-retention-modal-pin-after.png", {
    w: 275,
    h: 275
  });
  const sampleMessages = [
    'Add the text "#1 Fan" in white color onto the blue flag.',
    "Change the color of the dog's t-shirt from blue to red."
  ];
  const aiEdits = ["Text Added", "Color Changed"];
  const features = [
    "Option to send to human artist",
    "Background removal",
    "Add text, change color",
    "Direct print, fast delivery"
  ];

  return (
    <div
      {...restProps}
      className={cn("font-inter space-y-4", restProps.className)}
      data-testid="artist-edits-info"
    >
      <div className="relative">
        {isMobile ? (
          <button
            className="absolute right-0 top-0 cursor-pointer border-0 bg-transparent p-0"
            type="button"
            data-testid="artist-edits-info-close-button"
            onClick={() => {
              onClose?.();
            }}
          >
            <UseSvg className="h-5 w-5" icon="menu-close" data-testid="h-5" />
          </button>
        ) : null}
        <h2 className="text-base font-bold leading-6">AI Edits — How it works</h2>
        <p className="text-xs leading-[130%] text-gray-600">
          {" "}
          AI analyzes your edit request and decides if it can complete automatically or requires our{" "}
          <strong>Free</strong> professional edit service, which happens after checkout.{" "}
        </p>
      </div>
      <div className="relative flex rounded-xl border-[3px] border-gray-200 p-1.5">
        {}
        <div className="absolute left-1/2 top-1/3 z-10 -translate-x-1/2">
          <div className="flex size-8 items-center justify-center rounded-full bg-black shadow-md">
            <UseSvg className="h-5 w-5 text-white" icon="arrow-right-long" data-testid="h-5-1" />
          </div>
        </div>
        {}
        <div className="flex flex-1 flex-col gap-3 px-0 py-2">
          <div className="flex flex-col items-center gap-2">
            <p className="!mb-0 h-6 text-center text-xs font-medium leading-6">Original Upload</p>
            <img
              className="w-full max-w-[180px] object-cover"
              src={beforeImage}
              alt="Before AI edits"
            />
          </div>
          <div className="space-y-2">
            <p className="text-center text-xs font-bold leading-4 text-gray-800">Sample message:</p>
            {renderList(sampleMessages, (message, index) => (
              <div
                className="flex items-start gap-2"
                key={message}
                data-testid={`sample-message-${index}`}
              >
                <div className="flex size-5 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white">
                  {index + 1}
                </div>
                <span className="text-[11px] font-medium leading-4 text-gray-600">{message}</span>
              </div>
            ))}
          </div>
        </div>
        {}
        <div className="flex flex-1 flex-col gap-3 rounded-lg bg-purple-100 px-0 py-2">
          <div className="flex flex-col items-center gap-2">
            <div className="flex h-6 items-center gap-2">
              <StarsIcon className="h-6 w-6 shrink-0" data-testid="h-6" />
              <p className="!mb-0 text-xs font-bold leading-4">AI Edited</p>
              <span
                className="rounded-full bg-green-700 px-1.5 py-0.5 text-xs font-medium text-white"
                data-testid="artist-edits-free-badge"
              >
                {" "}
                Free{" "}
              </span>
            </div>
            <img
              className="w-full max-w-[180px] object-cover mix-blend-multiply"
              src={afterImage}
              alt="After AI edits"
            />
          </div>
          <div className="space-y-2">
            <p className="text-center text-xs font-bold leading-4 text-gray-800">AI Edits:</p>
            <div className="flex justify-center">
              <div className="flex flex-col gap-2">
                {renderList(aiEdits, edit => (
                  <div
                    className="flex items-center gap-2"
                    key={edit}
                    data-testid={`artist-edit-${edit}`}
                  >
                    <CheckCircleIcon
                      className="size-5 shrink-0 text-green-700"
                      data-testid="size-5"
                    />
                    <span className="text-[11px] font-bold leading-4 text-gray-800">{edit}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      {}
      <div className="space-y-3">
        <p className="text-lg font-bold">What else do you get?</p>
        <div className="flex flex-wrap gap-x-4 gap-y-2">
          {renderList(features, feature => (
            <div className="flex items-center gap-1.5" key={feature}>
              <CheckIcon className="size-4 shrink-0 text-green-700" data-testid="size-4" />
              <span className="whitespace-nowrap text-[11px] font-medium leading-6 text-gray-900">
                {feature}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
